import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'kv'})
export class KeysPipe implements PipeTransform {
  transform(value: any, args: string[]): any {
    const keys: any = [];
    // tslint:disable-next-line:forin
    for (const key in value) {
      keys.push({key: key, value: value[key]});
    }
    return keys;
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/keys.pipe.ts